/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1742
 */

var r = require(/* 477 */"../../1720/477")
module.exports = function (e) {
  var t = r(e)
  if (t < 0) {
    throw RangeError("The argument can't be less than 0")
  }
  return t
}
